'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.handleAd = void 0;
var _base = require('../base/base');
function asyncGeneratorStep(e, r, n, t, a, o, c) {
    try {
        var s = e[o](c), u = s.value;
    } catch (e) {
        return void n(e);
    }
    s.done ? r(u) : Promise.resolve(u).then(t, a);
}
function _asyncToGenerator(s) {
    return function () {
        var e = this, c = arguments;
        return new Promise(function (r, n) {
            var t = s.apply(e, c);
            function a(e) {
                asyncGeneratorStep(t, r, n, a, o, 'next', e);
            }
            function o(e) {
                asyncGeneratorStep(t, r, n, a, o, 'throw', e);
            }
            a(void 0);
        });
    };
}
var handleAd = function () {
    var r = _asyncToGenerator(regeneratorRuntime.mark(function e(r) {
        var n, t, a, o;
        return regeneratorRuntime.wrap(function (e) {
            for (;;)
                switch (e.prev = e.next) {
                case 0:
                    if (n = null, e.prev = 1, !r.preload) {
                        e.next = 14;
                        break;
                    }
                    t = [], a = 0, t = 'string' == typeof r.preload ? [r.preload] : r.preload;
                case 6:
                    if (!(t.length > a)) {
                        e.next = 14;
                        break;
                    }
                    return o = t[a], console.log('load', o), e.next = 11, (0, _base.loadScript)(o, {
                        cache: !1,
                        reload: !1
                    });
                case 11:
                    ++a, e.next = 6;
                    break;
                case 14:
                    n = new Function('return '.concat(r.callback))(), e.next = 23;
                    break;
                case 17:
                    e.prev = 17, e.t0 = e.catch(1), e.t0.message = 'AdError - '.concat(e.t0.message), console.error(e.t0), console.error('AdError - AdData', r), window && window.BJ_REPORT && window.BJ_REPORT.report(e.t0, !1, 'ad');
                case 23:
                    return e.abrupt('return', n);
                case 24:
                case 'end':
                    return e.stop();
                }
        }, e, null, [[1,17]]);
    }));
    return function (e) {
        return r.apply(this, arguments);
    };
}();
exports.handleAd = handleAd;